var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __require = typeof require !== "undefined" ? require : (x) => {
  throw new Error('Dynamic require of "' + x + '" is not supported');
};
var __commonJS = (cb, mod) => function __require2() {
  return mod || (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// node_modules/@arr/every/index.js
var require_every = __commonJS({
  "node_modules/@arr/every/index.js"(exports, module2) {
    module2.exports = function(arr, cb) {
      var i = 0, len = arr.length;
      for (; i < len; i++) {
        if (!cb(arr[i], i, arr)) {
          return false;
        }
      }
      return true;
    };
  }
});

// node_modules/@poppinss/matchit/lib/matchit.js
var require_matchit = __commonJS({
  "node_modules/@poppinss/matchit/lib/matchit.js"(exports) {
    "use strict";
    var every = require_every();
    var SEP = "/";
    var STYPE = 0;
    var PTYPE = 1;
    var ATYPE = 2;
    var OTYPE = 3;
    var SLASH = 47;
    var COLON = 58;
    var ASTER = 42;
    var QMARK = 63;
    function strip(str) {
      if (str === SEP)
        return str;
      str.charCodeAt(0) === SLASH && (str = str.substring(1));
      var len = str.length - 1;
      return str.charCodeAt(len) === SLASH ? str.substring(0, len) : str;
    }
    function split(str) {
      return (str = strip(str)) === SEP ? [SEP] : str.split(SEP);
    }
    function isMatch(arr, obj, idx) {
      idx = arr[idx];
      if (obj.val === idx && obj.type === STYPE) {
        return true;
      }
      if (idx === SEP) {
        return obj.type > PTYPE;
      }
      if (obj.type === STYPE) {
        return false;
      }
      if (idx === "") {
        return obj.end === "" && (!!obj.matcher ? obj.matcher.test(idx) : true);
      }
      if (!idx) {
        return obj.end === "";
      }
      return idx.endsWith(obj.end) && (!!obj.matcher ? obj.matcher.test(idx) : true);
    }
    function match2(str, all) {
      let segs = split(str), len = segs.length, l;
      let i = 0, tmp;
      var fn = isMatch.bind(isMatch, segs);
      for (; i < all.length; i++) {
        tmp = all[i];
        if ((l = tmp.length) === len || l < len && tmp[l - 1].type === ATYPE || l > len && tmp[l - 1].type === OTYPE) {
          if (every(tmp, fn))
            return tmp;
        }
      }
      return [];
    }
    function parse2(str, matchers) {
      if (str === SEP) {
        return [{ old: str, type: STYPE, val: str, end: "" }];
      }
      if (typeof matchers !== "object") {
        matchers = {};
      }
      let c, x, t, sfx, val, nxt = strip(str), i = -1, j = 0, len = nxt.length, out = [];
      while (++i < len) {
        c = nxt.charCodeAt(i);
        if (c === COLON) {
          j = i + 1;
          t = PTYPE;
          x = 0;
          sfx = "";
          while (i < len && nxt.charCodeAt(i) !== SLASH) {
            c = nxt.charCodeAt(i);
            if (c === QMARK) {
              x = i;
              t = OTYPE;
            } else if (c === 46 && sfx.length === 0) {
              sfx = nxt.substring(x = i);
            }
            i++;
          }
          val = nxt.substring(j, x || i);
          const matcher = matchers[val];
          out.push({
            old: str,
            type: t,
            val,
            end: sfx,
            matcher: matcher && matcher.match,
            cast: matcher && matcher.cast
          });
          nxt = nxt.substring(i);
          len -= i;
          i = 0;
          continue;
        } else if (c === ASTER) {
          out.push({
            old: str,
            type: ATYPE,
            val: nxt.substring(i),
            end: ""
          });
          continue;
        } else {
          j = i;
          while (i < len && nxt.charCodeAt(i) !== SLASH) {
            ++i;
          }
          val = nxt.substring(j, i);
          out.push({
            old: str,
            type: STYPE,
            val,
            end: ""
          });
          nxt = nxt.substring(i);
          len -= i;
          i = j = 0;
        }
      }
      return out;
    }
    function exec(str, arr) {
      let i = 0, x, y, segs = split(str), out = {};
      for (; i < arr.length; i++) {
        x = segs[i];
        y = arr[i];
        if (x === SEP)
          continue;
        if (y.val === "*") {
          out[y.val] = segs.slice(i);
          break;
        }
        if (x !== void 0 && y.type | OTYPE === 2) {
          const value = x.replace(y.end, "");
          out[y.val] = y.cast ? y.cast(value) : value;
        }
      }
      return out;
    }
    exports.exec = exec;
    exports.match = match2;
    exports.parse = parse2;
  }
});

// src/client/index.ts
__export(exports, {
  initRoutes: () => initRoutes,
  stardust: () => stardust
});

// src/client/Stardust.ts
var import_matchit = __toModule(require_matchit());

// src/client/UrlBuilder.ts
var UrlBuilder = class {
  constructor(routes) {
    this.routes = routes;
    __publicField(this, "routeParams");
    __publicField(this, "queryString", {});
    __publicField(this, "baseUrl");
  }
  processPattern(pattern) {
    let url = [];
    const isParamsAnArray = Array.isArray(this.routeParams);
    const tokens = pattern.split("/");
    let paramsIndex = 0;
    for (const token of tokens) {
      if (token === "*") {
        const wildcardParams = isParamsAnArray ? this.routeParams.slice(paramsIndex) : this.routeParams["*"];
        if (!Array.isArray(wildcardParams)) {
          throw new Error("Wildcard param must pass an array of values");
        }
        if (!wildcardParams.length) {
          throw new Error(`Wildcard param is required to make URL for "${pattern}" route`);
        }
        url = url.concat(wildcardParams);
        break;
      }
      if (!token.startsWith(":")) {
        url.push(token);
      } else {
        const isOptional = token.endsWith("?");
        const paramName = token.replace(/^:/, "").replace(/\?$/, "");
        const param = isParamsAnArray ? this.routeParams[paramsIndex] : this.routeParams[paramName];
        paramsIndex++;
        if (!param && !isOptional) {
          throw new Error(`"${param}" param is required to make URL for "${pattern}" route`);
        }
        url.push(param);
      }
    }
    return url.join("/");
  }
  findRouteOrFail(identifier) {
    const route = this.routes[identifier];
    if (!route) {
      throw new Error(`Cannot find route for "${identifier}"`);
    }
    return route;
  }
  suffixQueryString(url) {
    if (this.queryString) {
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(this.queryString)) {
        if (Array.isArray(value)) {
          value.forEach((item) => params.append(key, item));
        } else {
          params.set(key, value);
        }
      }
      const encoded = params.toString();
      url = encoded ? `${url}?${encoded}` : url;
    }
    return url;
  }
  prefixUrl(url) {
    if (url) {
      this.baseUrl = url;
    }
    return this;
  }
  qs(queryString) {
    if (queryString) {
      this.queryString = queryString;
    }
    return this;
  }
  params(params) {
    if (params) {
      this.routeParams = params;
    }
    return this;
  }
  make(identifier) {
    const route = this.findRouteOrFail(identifier);
    const url = this.processPattern(route);
    return this.suffixQueryString(this.baseUrl ? `${this.baseUrl}${url}` : url);
  }
};

// src/client/Stardust.ts
var Stardust = class {
  constructor(namedRoutes) {
    __publicField(this, "routes", {});
    __publicField(this, "reverseRoutes", {});
    __publicField(this, "parsedRoutePatterns");
    if (!namedRoutes) {
      console.error("Routes could not be found. Please make sure you use the `@routes()` tag in your view!");
      return;
    }
    const parsedRoutePatterns = Object.entries(namedRoutes).map(([, pattern]) => (0, import_matchit.parse)(pattern));
    this.routes = namedRoutes;
    this.reverseRoutes = Object.fromEntries(Object.entries(namedRoutes).map(([key, value]) => [value, key]));
    this.parsedRoutePatterns = parsedRoutePatterns;
  }
  getRoutes() {
    return this.routes;
  }
  builder() {
    return new UrlBuilder(this.routes);
  }
  route(route, params, options) {
    return new UrlBuilder(this.routes).params(params).qs(options == null ? void 0 : options.qs).prefixUrl(options == null ? void 0 : options.prefixUrl).make(route);
  }
  get current() {
    const [matchedRoute] = (0, import_matchit.match)(this.pathname, this.parsedRoutePatterns);
    if (!matchedRoute) {
      return null;
    }
    const { old: pattern } = matchedRoute;
    return this.reverseRoutes[pattern];
  }
  get pathname() {
    if (globalThis.stardust.pathname) {
      return globalThis.stardust.pathname;
    }
    const { pathname } = new URL((window != null ? window : globalThis).location.href);
    return pathname;
  }
  isCurrent(route) {
    return route === this.current;
  }
};

// src/client/index.ts
var stardust;
function initRoutes() {
  const { namedRoutes } = (globalThis != null ? globalThis : window).stardust;
  stardust = new Stardust(namedRoutes);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  initRoutes,
  stardust
});
